export default __webpack_public_path__ + "static/media/shark.a3000fc8.png";